export default __webpack_public_path__ + "img/Google hybrid-1a7e84e7389eb4bf451d7752e73c7509.jpg";